/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Compatibility_AInputs */

const en_gc_resources_faq_compatibility_a = /** @type {(inputs: Gc_Resources_Faq_Compatibility_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft uses XLSX as its native format, but it is still in alpha. Complex formatting, advanced formulas and other Excel features may not round-trip exactly. Test a copy and keep your original file.`)
};

const zh_gc_resources_faq_compatibility_a = /** @type {(inputs: Gc_Resources_Faq_Compatibility_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 原生使用 XLSX 格式，但仍处于 Alpha 阶段。复杂格式、高级公式及其他 Excel 功能可能无法完整保留。请使用副本测试并保留原文件。`)
};

/**
* | output |
* | --- |
* | "GridCraft uses XLSX as its native format, but it is still in alpha. Complex formatting, advanced formulas and other Excel features may not round-trip exactly..." |
*
* @param {Gc_Resources_Faq_Compatibility_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_compatibility_a = /** @type {((inputs?: Gc_Resources_Faq_Compatibility_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Compatibility_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_compatibility_a(inputs)
	return zh_gc_resources_faq_compatibility_a(inputs)
});
export { gc_resources_faq_compatibility_a as "gc.resources.faq.compatibility.a" }